import { render } from "./MessageBox.vue?vue&type=template&id=084b2ef6&scoped=true&ts=true"
import script from "./MessageBox.vue?vue&type=script&lang=ts"
export * from "./MessageBox.vue?vue&type=script&lang=ts"

import "./MessageBox.vue?vue&type=style&index=0&id=084b2ef6&lang=scss&scoped=true"

import exportComponent from "/var/lib/jenkins/workspace/hems-frontend-vue_eu_v1.33.0/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-084b2ef6"]])

export default __exports__